interface mrjoeSessionData {
  account_id: string;
  first_name: string;
  last_name: string;
  company_code: string;
  company_name: string;
  subscription_status: string;
}


export const formatCurrency = (
 value: number | string,
 decimalPlaces: number = 2
): string => {
 // Handle empty or invalid values
 if (value === null || value === undefined || value === '') {
   return '';
 }

 // Convert to number if string
 const numValue = typeof value === 'string' ? parseFloat(value) : value;

 // Check if valid number
 if (isNaN(numValue)) {
   return '';
 }

 // Format with commas and fixed decimal places
 return numValue.toLocaleString('en-US', {
   minimumFractionDigits: decimalPlaces,
   maximumFractionDigits: decimalPlaces,
 });
};


export function formatAddress(
  address1?: string,
  address2?: string,
  city?: string,
  state?: string,
  zip?: string
): string {
  return [address1?.trim(), address2?.trim(), city?.trim(), state?.trim(), zip?.trim()]
    .filter((item) => item && item !== '')
    .join(', ');
}

export function getCurrentTimestamp(): string {
  return new Date().toISOString();
}

export function getCurrentDate(): string {
  return new Date().toISOString().split('T')[0];;
}

export function getCompanyCodeFromSessionStorage(sessionStorageKey: string): string {

  let companyCode = ''; // Use `let` to avoid redeclaration issues

  const sessionData = sessionStorage.getItem(sessionStorageKey);
  if (sessionData) {
    const parsedSessionData = JSON.parse(atob(sessionData));
    companyCode = parsedSessionData.company_code || '';  // Assign value to the existing `companyCode`
    // Perform any additional logic here if needed
  }

  return companyCode;
}

export function getAccountIdFromSessionStorage(sessionStorageKey: string): string {

  let AccountId = ''; // Use `let` to avoid redeclaration issues

  const sessionData = sessionStorage.getItem(sessionStorageKey);
  if (sessionData) {
    const parsedSessionData = JSON.parse(atob(sessionData));
    AccountId = parsedSessionData.account_id || '';  // Assign value to the existing `companyCode`
    // Perform any additional logic here if needed
  }

  return AccountId;
}


export const removeSessionData = (key: string) => {
  // Remove from sessionStorage. Usually it is for logout
  sessionStorage.removeItem(key);
  // If you are also using cookies, you might want to remove them like this:
  //document.cookie = `${key}=; max-age=0; path=/;`;
}

export const updateSessionStorageSubscriptionStatus = (newStatus: string) => {
  // Get the session storage key
  const sessionStorageKey = process.env.REACT_APP_SESSION_STORAGE_KEY;

  if (sessionStorageKey) {
    const sessionData = sessionStorage.getItem(sessionStorageKey);
    if (sessionData) {
      const parsedSessionData = JSON.parse(atob(sessionData));
      parsedSessionData.subscription_status = newStatus || 'inactive';
      const encodedSessionData = btoa(JSON.stringify(parsedSessionData));
      sessionStorage.setItem(sessionStorageKey, encodedSessionData);

    }
  }
}


export function getSessionData(sessionStorageKey: string): mrjoeSessionData | null {
  const sessionData = sessionStorage.getItem(sessionStorageKey);
  if (sessionData) {
    try {
      const decodedData = JSON.parse(atob(sessionData));
      return decodedData; // Return the parsed object
    } catch (error) {
      //console.error('Failed to parse session data:', error);
      return null; // Return null in case of error
    }
  }
  return null; // Return null if no session data is found
}

export const formatDate = (dateString: string): string => {
  if (!dateString) return 'N/A';
  const datePart = dateString.split('T')[0]; // Handle both "2025-12-27" and "2025-12-27T..."
  const [year, month, day] = datePart.split('-');
  return `${month}/${day}/${year}`;
}

export const formatTimestamp = (timestamp: string): string => {
  if (!timestamp) return 'N/A';
  const date = new Date(timestamp);
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
}

//export const sanitizeErrorMessage = (message1: string | string[] ): string => {
// Remove email addresses
//console.log('---', message1)
//let message = Array.isArray(message1) ? message1.join(', ') : message1;

//message = message.replace(/\S+@\S+\.\S+/g, '[...]');
// Remove anything that looks like an API key or token (long alphanumeric strings)
//message = message.replace(/\b[A-Za-z0-9]{20,}\b/g, '[KEY REDACTED]');
// Add more patterns here as needed
//return message;
//};
